import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdAppGroupPermissionSetsCreatePermissionSetCacheKeys: AllRouteEndpoints[] = [];
